class StockistCarousel extends HTMLElement {
  connectedCallback() {
    this.slideContainers = this.querySelectorAll('[carousel-item]');
    if (this.slideContainers.length === 0) return;

    this.buttons = this.querySelectorAll('[slide-dash-button]');
    this.buttonDashes = this.querySelectorAll('[dash]');
    this.currentIndex = 0;
    this.startX = 0;
    this.endX = 0;
    this.isSwiping = false;

    this.buttons.forEach((button, index) => {
      button.dataset.index = index;
      button.addEventListener('click', () => this.showSlide(index));
      button.addEventListener('keydown', (ev) => {
        if (ev.code === 'Enter' || ev.code === 'Space') {
          this.showSlide(index);
        }
      });
    });

    this.slideContainers.forEach((slide) => {
      slide.addEventListener('click', (event) => {
        if (window.innerWidth <= 1023) {
          this.navigateToOpeningHours(e);
        } else {
          this.showNextSlide();
        }
      });

      if (window.innerWidth <= 1023) {
        slide.addEventListener('touchstart', this.handleTouchStart.bind(this), false);
        slide.addEventListener('touchmove', this.handleTouchMove.bind(this), false);
        slide.addEventListener('touchend', this.handleTouchEnd.bind(this), false);
      }
    });
  }

  handleTouchStart(e) {
    this.startX = e.touches[0].clientX;
    this.isSwiping = false;
  }

  handleTouchMove(e) {
    this.endX = e.touches[0].clientX;
    if (Math.abs(this.endX - this.startX) > 30) {
      this.isSwiping = true;
    }
  }

  handleTouchEnd(e) {
    const swipeDistance = this.startX - this.endX;
    if (this.isSwiping) {
      if (this.endX < this.startX) {
        this.showNextSlide();
      } else {
        this.showPreviousSlide();
      }
    } else {
      this.navigateToOpeningHours(e);
    }
  }

  showSlide(index) {
    this.currentIndex = index;
    this.updateCarousel();
  }

  showNextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.slideContainers.length;
    this.updateCarousel();
  }

  showPreviousSlide() {
    this.currentIndex = (this.currentIndex - 1 + this.slideContainers.length) % this.slideContainers.length;
    this.updateCarousel();
  }

  updateCarousel() {
    this.buttons.forEach((button, i) => {
      button.removeAttribute('aria-current');
      if (i === this.currentIndex) {
        button.setAttribute('aria-current', 'true');
      }
    });

    this.buttonDashes?.forEach((dash, i) => {
      dash.classList.toggle('bg-gray-600', i === this.currentIndex);
      dash.classList.toggle('bg-gray-200', i !== this.currentIndex);
    });

    this.slideContainers.forEach((slide, i) => {
      slide.classList.toggle('z-20', i === this.currentIndex);
      slide.classList.toggle('opacity-100', i === this.currentIndex);
      slide.classList.toggle('z-10', i !== this.currentIndex);
      slide.classList.toggle('opacity-0', i !== this.currentIndex);
      slide.setAttribute('aria-hidden', i !== this.currentIndex);
    });
  }

  navigateToOpeningHours(e) {
    const root = e.target.closest('stockist-carousel');
    const link = root?.parentElement?.querySelector('.opening-hours a');

    if (link?.href) {
      window.location.href = link.href;
    }
  }
}

customElements.define('stockist-carousel', StockistCarousel);
